import { StyleSheet } from 'react-native';
import { FONTS } from '../../constants';

export const myPreferenceStyled = StyleSheet.create({
  container: {
    paddingHorizontal: 20,
  },
  headerText: {
    fontSize: 14,
    letterSpacing: 1,
    textTransform: 'uppercase',
    color: '#fff',
    fontWeight: '500',
    fontFamily: FONTS.IowanOldStyleBTRoman,
  },
});
